import React, {Component} from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import './BlockTimeSelector.css'
import TimeRange from "../utils/TimeRange";

class BlockTimeSelector extends Component {

    constructor(props) {

        super(props);
        // console.debug("Construct TimerangeSelector");

        if (!props.TimeRange) {
            throw new Error("TimeRange not set");
        }

        let year = moment().year();

        this.state = {
            currentYear: year
        };

        this.selectYear = this.selectYear.bind(this);
        this.selectQuarter = this.selectQuarter.bind(this);
        this.selectMonth = this.selectMonth.bind(this);
        this.changeYear = this.changeYear.bind(this);
        this.notifyParent = this.notifyParent.bind(this);

    };

    selectYear(evt) {

        evt.preventDefault();

        let tr = new TimeRange();

        tr.setBlock(this.state.currentYear, null, null);

        this.notifyParent(tr);

    }

    selectQuarter(evt, quarter) {

        evt.preventDefault();

        let tr = new TimeRange();

        tr.setBlock(this.state.currentYear, quarter, null);

        this.notifyParent(tr);

    }

    selectMonth(evt, month) {

        evt.preventDefault();

        let tr = new TimeRange();

        tr.setBlock(this.state.currentYear, null, month);

        this.notifyParent(tr);

    }

    changeYear(evt, value) {

        evt.preventDefault();

        this.setState({currentYear: this.state.currentYear + value});

    }

    notifyParent(timeRange) {

        if (!this.props.onChange)
            return;

        this.props.onChange(timeRange);

    }

    render() {

        return (
            <div>
                <table className="table blockTimeSelector">
                    <thead>
                        <tr>
                            <th colSpan="4" onClick={(e) => this.changeYear(e, -1)} style={{textAlign: 'left'}}>
                                <a href="#Last"> &lt; </a>
                            </th>
                            <th colSpan="4"
                                className={this.props.TimeRange.isBlock(this.state.currentYear, null, null) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectYear(e)}
                                style={{textAlign: 'center'}}>
                                {this.state.currentYear}
                            </th>
                            <th colSpan="4" onClick={(e) => this.changeYear(e, 1)} style={{textAlign: 'right'}}>
                                <a href="#Next"> &gt; </a>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {/*Quarters*/}
                        <tr className={"selectQuarters"}>
                            <td colSpan="3"
                                className={this.props.TimeRange.isBlock(this.state.currentYear, 1, null) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectQuarter(e, 1)}
                            >Q1
                            </td>
                            <td colSpan="3"
                                className={this.props.TimeRange.isBlock(this.state.currentYear, 2, null) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectQuarter(e, 2)}
                            >Q2
                            </td>
                            <td colSpan="3"
                                className={this.props.TimeRange.isBlock(this.state.currentYear, 3, null) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectQuarter(e, 3)}
                            >Q3
                            </td>
                            <td colSpan="3"
                                className={this.props.TimeRange.isBlock(this.state.currentYear, 4, null) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectQuarter(e, 4)}
                            >Q4
                            </td>
                        </tr>

                        {/*Months*/}
                        <tr className={"selectMonths"}>
                            <td className={this.props.TimeRange.isBlock(this.state.currentYear, null, 1) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectMonth(e, 1)}>
                                1
                            </td>
                            <td className={this.props.TimeRange.isBlock(this.state.currentYear, null, 2) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectMonth(e, 2)}>
                                2
                            </td>
                            <td className={this.props.TimeRange.isBlock(this.state.currentYear, null, 3) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectMonth(e, 3)}>
                                3
                            </td>
                            <td className={this.props.TimeRange.isBlock(this.state.currentYear, null, 4) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectMonth(e, 4)}>
                                4
                            </td>
                            <td className={this.props.TimeRange.isBlock(this.state.currentYear, null, 5) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectMonth(e, 5)}>
                                5
                            </td>
                            <td
                                className={this.props.TimeRange.isBlock(this.state.currentYear, null, 6) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectMonth(e, 6)}>
                                6
                            </td>
                            <td className={this.props.TimeRange.isBlock(this.state.currentYear, null, 7) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectMonth(e, 7)}>
                                7
                            </td>
                            <td className={this.props.TimeRange.isBlock(this.state.currentYear, null, 8) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectMonth(e, 8)}>
                                8
                            </td>
                            <td
                                className={this.props.TimeRange.isBlock(this.state.currentYear, null, 9) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectMonth(e, 9)}>
                                9
                            </td>
                            <td className={this.props.TimeRange.isBlock(this.state.currentYear, null, 10) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectMonth(e, 10)}>
                                10
                            </td>
                            <td className={this.props.TimeRange.isBlock(this.state.currentYear, null, 11) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectMonth(e, 11)}>
                                11
                            </td>
                            <td className={this.props.TimeRange.isBlock(this.state.currentYear, null, 12) ? "blockTimeSelector-active" : ''}
                                onClick={(e) => this.selectMonth(e, 12)}>
                                12
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );

    }

}

export default BlockTimeSelector;